const USDV = 'usdv'
const VADER = 'vader'
const VETHER = 'vether'
const VAULT = 'vault'


export {
	USDV,
	VADER,
	VETHER,
	VAULT,
}